export default __webpack_public_path__ + "static/media/bkg--interiors-2.6fdc4704.jpg";